<template>
  <CareWebview class="bg-surface-brand-hi">
    <component :is="homeComponent" />
  </CareWebview>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'

import CareWebview from '~/scopes/care-commons/webview/CareWebview.vue'

import LegacyHelpCenterHome from '../components/LegacyHelpCenterHome/LegacyHelpCenterHome.vue'

import HelpCenterHome from './help/components/HelpCenterHome/HelpCenterHome.vue'

const { FF_ENABLE_NEW_HELP_CENTER } = useRuntimeConfig().public

const homeComponent = FF_ENABLE_NEW_HELP_CENTER
  ? HelpCenterHome
  : LegacyHelpCenterHome
</script>
